export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40c7df0b169a3d44e750703ff50f7a2268961f3501&name=revalidateCommunity!'